// src/pages/ServicePage.jsx
import React from "react";
import Hero from "../components/hero/Hero";
import serviceHero from "../assets/images/serviceHero.png";
import pinjamanTunai from "../assets/images/pinjamanTunai.png";
import pinjamanPensiun from "../assets/images/pinjamanPensiun.png";
import pinjamanMultiguna from "../assets/images/pinjamanMultiguna.png";
import pembelianPembayaran from "../assets/images/pembelianPembayaran.png";
import tiketHotel from "../assets/images/tiketHotel.png";
import cicilanEmas from "../assets/images/cicilanEmas.png";
import pinjamanPayroll from "../assets/images/pinjamanPayroll.png";
import cicilanGadget from "../assets/images/cicilan-gadget.png";
import Footer from "../components/footer/Footer";

const ServicePage = () => {
  const categories = [
    {
      id: 1,
      title: "TomiDana",
      description:
        "Produk pinjaman yang ditujukan untuk karyawan dengan sistem pemotongan langsung dari gaji bulanan. Cicilan ringan sesuai dengan kemampuan finansial karyawan.",
      icon: pinjamanPayroll,
    },
    {
      id: 2,
      title: "Pinjaman Tunai",
      description:
        "Solusi pinjaman pribadi yang dapat digunakan untuk berbagai keperluan mendesak seperti biaya pendidikan, kesehatan, atau kebutuhan harian, dengan proses cepat dan fleksibel.",
      icon: pinjamanTunai,
    },
    {
      id: 3,
      title: "Pinjaman Pensiun",
      description:
        "Pinjaman khusus untuk pensiunan dengan skema pembayaran yang disesuaikan dengan dana pensiun bulanan. Aman dan terpercaya untuk menopang kebutuhan di masa pensiun.",
      icon: pinjamanPensiun,
    },
    {
      id: 4,
      title: "Pinjaman Multiguna",
      description:
        "Pinjaman serbaguna yang dapat digunakan untuk keperluan apa pun, seperti renovasi rumah, modal usaha, atau pembelian barang elektronik, dengan jaminan tertentu.",
      icon: pinjamanMultiguna,
    },
    {
      id: 5,
      title: "Pembelian & Pembayaran",
      description:
        "Fasilitas untuk melakukan transaksi pembelian produk atau pembayaran tagihan secara praktis dan aman melalui platform yang terintegrasi.",
      icon: pembelianPembayaran,
    },
    {
      id: 6,
      title: "Tiket & Hotel",
      description:
        "Layanan pembelian tiket perjalanan dan pemesanan hotel secara online dengan harga kompetitif dan proses mudah, cocok untuk kebutuhan liburan atau perjalanan bisnis.",
      icon: tiketHotel,
    },
    {
      id: 7,
      title: "Cicilan Emas",
      description:
        "Program pembelian emas dengan sistem cicilan terjangkau. Cocok bagi yang ingin berinvestasi emas secara bertahap dengan keamanan yang terjamin.",
      icon: cicilanEmas,
    },
    {
      id: 8,
      title: "TomiGawai",
      description:
        "Solusi cicilan gadget yang memudahkan Anda memiliki perangkat pilihan dengan proses praktis dan pembayaran yang terjangkau.",
      icon: cicilanGadget,
    },
    // {
    //   id: 9,
    //   title: "Lain-lain",
    //   description:
    //     "Kategori ini mencakup berbagai layanan dan produk tambahan di luar kategori utama, sesuai dengan kebutuhan finansial pengguna.",
    //   icon: "/images/lainnya.png",
    // },
  ];

  return (
    <>
      <main>
        {/* Hero Section */}
        <Hero
          title="Kami menyediakan berbagai layanan terbaik"
          subtitle="Mulai dari pembayaran tagihan, pembelian pulsa, hingga layanan transaksi digital lainnya semua dapat diakses dengan mudah, aman, dan cepat di satu platform. Semua layanan favorit Anda, mudah diakses dalam satu aplikasi."
          align="left"
          imageHero={serviceHero}
        />

        {/* Layanan Kami */}
        <div className="section-shell bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="section-title">Layanan Kami</h2>
              <p className="section-copy mx-auto mt-2 max-w-2xl">
                Di Tomi Anda bisa menemukan semuanya{" "}
                <span className="font-semibold">dalam satu platform</span>
              </p>
            </div>

            {/* Dua Card Layanan - Dibatasi Lebar */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {/* Card 1: Pembayaran & Pinjaman */}
              <div className="modern-card mx-auto max-w-md overflow-hidden">
                {/* Header Biru */}
                <div className="flex flex-col items-center bg-[#3f6fe5] p-7 text-white">
                  <div className="mb-3 rounded-full bg-white/15 px-3 py-1 text-sm font-bold text-white ring-1 ring-white/20">
                    #1
                  </div>
                  <div className="mb-3">
                    <svg
                      className="w-10 h-10 mx-auto"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 19v-6a2 2 0 002-2h2a2 2 0 002 2v6M7 7v6M17 7v6"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 3v1m0 16v1m9-9h-1M4 12H3m6 6h.01M5 5h-.01M15 5h-.01M12 12h.01M12 12v.01"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-center">
                    Pembayaran & Pinjaman
                  </h3>
                </div>
                {/* Body Putih */}
                <div className="p-6">
                  <p className="section-copy mb-4">
                    Kami bantu Anda temukan pinjaman terbaik dari lembaga resmi,
                    dengan proses transparan dan bunga kompetitif.
                  </p>
                  <hr className="my-4 border-gray-300" />
                  <ul className="space-y-2 text-sm text-slate-700">
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Pinjaman Produktif</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Pinjaman Konsumtif</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Simulasi angsuran langsung di platform</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Card 2: Layanan Keuangan Digital */}
              <div className="modern-card mx-auto max-w-md overflow-hidden">
                {/* Header Biru */}
                <div className="flex flex-col items-center bg-[#3f6fe5] p-7 text-white">
                  <div className="mb-3 rounded-full bg-white/15 px-3 py-1 text-sm font-bold text-white ring-1 ring-white/20">
                    #2
                  </div>
                  <div className="mb-3">
                    <svg
                      className="w-10 h-10 mx-auto"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 10h18v6H3v-6z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M14 10V6a1 1 0 00-1-1H9a1 1 0 00-1 1v4M3 10a1 1 0 100 2h18a1 1 0 100-2H3z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-center">
                    Layanan Keuangan Digital
                  </h3>
                </div>
                {/* Body Putih */}
                <div className="p-6">
                  <p className="section-copy mb-4">
                    Semua kebutuhan transaksi Anda. Mulai dari pembayaran,
                    e-wallet, hingga layanan keuangan lainnya, tersedia dan bisa
                    diakses langsung lewat satu aplikasi.
                  </p>
                  <hr className="my-4 border-gray-300" />
                  <ul className="space-y-2 text-sm text-slate-700">
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Integrasi dengan berbagai fintech</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Cocok untuk individu maupun UMKM</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <svg
                        className="w-4 h-4 text-green-500 mt-1"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Praktis dan efisien</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-shell section-band">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Judul Section */}
          <div className="text-center mb-10">
            <h2 className="section-title">
              Kategori Produk
            </h2>
            <p className="section-copy mx-auto mt-3 max-w-3xl">
              Temukan berbagai layanan yang telah dikelompokkan berdasarkan
              kebutuhan Anda, dari pinjaman hingga cicilan emas, semuanya ada di
              sini.
            </p>
          </div>

          {/* Grid Kategori */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((category) => (
              <div
                key={category.id}
                className="modern-card group p-7 text-center"
              >
                <div className="flex justify-center mb-4">
                  <img
                    src={category.icon}
                    alt={category.title}
                    className="w-16 h-16 object-contain group-hover:scale-110 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-lg font-semibold text-slate-900">
                  {category.title}
                </h3>
                <p className="section-copy mt-2">
                  {category.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ServicePage;
